.root {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 30px);
  min-height: 250px;
  margin-top: 30px;
  color: var(--widget-header-color);
  background: var(--widget-background);
  border: 3px dashed var(--widget-header-background);
  border-radius: 5px;
  transition: all 0.2s;

  &:hover {
    opacity: 0.8;
  }
}
